import React, { Component } from "react";
import { withControlPoints } from "../../../shared/containers/containerControlPoints";
import styles from "./controlPoints.module.scss";
import ControlPointsMap from "./ControlPointsMap";
import { withRoutes } from "../../../shared/containers/containerRoutes";
import RouteControlPoints from "./RouteControlPoints";

class ControlPoints extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  componentDidMount() {}

  componentDidUpdate(prevProps) {}

  render() {
    return (
      <div className={styles.controlPointsContainer}>
        <RouteControlPoints />
        <ControlPointsMap />
      </div>
    );
  }
}

export default withRoutes(withControlPoints(ControlPoints));
